<template>
  <b-container>
    <div class="controles">
      <h2 class="mt-3">Solicitud de trabajo</h2>
      
      <b-button  type="button" variant="secondary" class="ml-3 mt-3" href="/home/listado-ventas" >Solicitudes abiertas</b-button>
      <b-button  type="button" variant="secondary" class="ml-3 mt-3" href="/home/listado-ventas-cerrada" >Solicitudes cerrada</b-button>
      
    </div>
    <p class="text-danger"> * Obligatorio</p>
    <b-form @submit="onSubmit">
      
      <vendedorForm :vendedor_data="dataform" ></vendedorForm>

      <b-button  :disabled="errors.any() || !dataform.cliente || !wait" type="submit" variant="primary" class="mb-5">Enviar</b-button>
     
      
    </b-form>
    
  </b-container>
</template>

<script>
  import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
  import vendedorForm from '@/components/vendedor/vendedorForm'
  import {mapActions,mapState} from 'vuex'
  import Vue from 'vue'
  import axios from 'axios'
  export default {
    components:{
      vendedorForm
    },     
    mixins : [validateMixin],

    data() {
      return {
        dataform: {
          cliente: '',
          producto: '',
          cantidad: '',
          trabajo: [],
          fecha:'',
          hora:'',
          otro: '',
          solicitante:'',
          urls:[{
            value:''
          }],
          observaciones:'',
          status:'',
          
         
        },
        //solicitantes:[ 'Edgar Martinez','Jorge Martinez','Nancy Tamez','Elizabet Martinez','Roberto Martinez'],
        reset:false,
        disabled: 0,
        folio:'',
        wait:true,
      }
    },
    mounted(){
      //this._fetchSolicitantes() 
    },
    computed:{
      ...mapState('vendedor',['isOk']),
      ...mapState('login',['id'])//variable del state que tiene el id del login.
      
    },
    methods: {
      ...mapActions({
          _create: 'vendedor/create',
          __addurl: 'vendedor/addUrl'
         // _fetchSolicitantes: 'admin/fetchSolicitantes'
      }),
      async onSubmit(evt){
          
          evt.preventDefault()
          this.wait = false
          let url = "api/addformsale"//la direccion de la api
          this.reset = false
          
          const validate = await this.$validator.validateAll()
          if(!validate) {
             return false
          } 
          this.dataform.solicitante = this.id //se guarda en el dataform el id del usuario logueado.
          
     
          let values = new FormData()
          values.append('cliente',this.dataform.cliente)
          values.append('producto',this.dataform.producto) 
          values.append('cantidad',this.dataform.cantidad)
          values.append('trabajo',this.dataform.trabajo)
          values.append('fecha',this.dataform.fecha)
          values.append('hora',this.dataform.hora)
          values.append('otro',this.dataform.otro)
          values.append('solicitante',this.dataform.solicitante)
          values.append('observaciones',this.dataform.observaciones)
          values.append('status',this.dataform.status)      

          try {
          let response = await Vue.axios({
            method: 'POST',
            url: url,
            data: values 
          })
          this.folio = response.data.data.id
          this.wait = true
          this.dataform.urls.forEach(this.getUrl)
              

              this.$toasted.show('El formulario se guardo correctamente', { 
	 							theme: "bubble", 
	 							position: "top-right", 
	 							duration : 3000
              })
            this.onReset()
        }
        catch(error){
             this.$toasted.show(this.error, {
	 					  duration : 3000
						})
        }
        
        },
        onReset(){
            this.clearForm()
            this.clearErrors()
        },
        clearForm(){
          Object.assign(this.$data, this.$options.data.apply(this))
        },
        clearErrors(){
          this.reset = true
        
          this.$validator.reset()
        },
        getUrl(item, index) {
          let payload = []
          payload.id = this.folio
          payload.url = item.value
          console.warn(payload)
          this.__addurl(payload)
        }

    }
  }
</script>

<style lang="scss" scoped>
.controles{
    display:flex;
    margin-top:1em;
    align-items: center;
}
h2{
    align-self:center;
}

.volver{
    margin-left:1em;
}
@media screen and (max-width: 576px) {
    .controles{
        flex-direction: column;
        padding:0;
        margin:0;
        
    }
}
</style>